import React from "react";

export default function BoxShell() {
  return <React.Fragment />;
}

BoxShell.displayName = "ListBox.Box";
